export var props = {
  reward: {
    type: Object,
    required: true,
    default() {
      return {
        id: '',
        // id
        img: '',
        // 配图
        name: '',
        // 名称
        expire: 0,
        // 过期时间
        num: 0,
        // 数量
        coins: 0,
        // 价值
        tag: '' // 显示的标签图片链接
      };
    }
  },
  idx: {
    type: Number,
    required: false,
    default: 0
  }
};